var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { formatPretax } from './form-utils';
export var handleDisableBtn = function (formError, inputErrors) {
    // Create a shallow copy of formError
    var filteredFormError = __assign({}, formError);
    // Remove tryAgain404 and receiptAlreadyAddedError if they exist
    delete filteredFormError.tryAgain404;
    delete filteredFormError.receiptAlreadyAddedError;
    return (Object.keys(filteredFormError).length > 0 ||
        Object.values(inputErrors).some(function (item) { return item !== 'success'; }));
};
var formatDate = function (date) {
    var newDate = new Date(date).toLocaleDateString('fr-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC',
    });
    return newDate;
};
export var makeOnlineRequestBody = function (svocId, orderNumber, orderDate, email) {
    return {
        customerAccountId: svocId,
        onlineReceipts: [
            {
                orderNumber: orderNumber,
                emailId: email,
                orderDate: formatDate(orderDate),
            },
        ],
    };
};
export var makeInStoreRequestBody = function (svocId, receiptNumber, salesDate, preTaxAmount) {
    var _a = receiptNumber.split('-'), storeNumber = _a[0], registerNumber = _a[1], transactionId = _a[2];
    return {
        customerAccountId: svocId,
        storeReceipts: [
            {
                storeNumber: storeNumber,
                transactionId: transactionId,
                registerNumber: registerNumber,
                preTaxAmount: formatPretax(preTaxAmount),
                saleDate: formatDate(salesDate),
            },
        ],
    };
};
